/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { ExceptionResponseDTO } from '../model/models';
import { GetProfiloServizio409Response } from '../model/models';
import { GetProfiloServizio422Response } from '../model/models';
import { NegozioCreationForm } from '../model/models';
import { NegozioDTO } from '../model/models';
import { NegozioPatchForm } from '../model/models';
import { Pageable } from '../model/models';
import { PagedModelNegozioDTO } from '../model/models';


import { Configuration }                                     from '../configuration';


export interface CreaNegozioEsercenteRequestParams {
    negozioCreationForm: NegozioCreationForm;
}

export interface DeleteNegozioEsercenteRequestParams {
    idNegozio: string;
}

export interface GetNegozioEsercenteRequestParams {
    idNegozio: string;
}

export interface ListNegoziEsercenteRequestParams {
    pageable: Pageable;
}

export interface UpdateNegozioEsercenteRequestParams {
    idNegozio: string;
    negozioPatchForm: NegozioPatchForm;
}


export interface EsercenteNegoziServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Crea un punto vendita.
     * Crea un negozio sotto il ProfiloEsercente del caller (nome/indirizzo obbligatori, normalizzati uppercase+trim). 422 se nome/indirizzo blank.
     * @endpoint post /api/v1/esercente/negozi
* @param requestParameters
     */
    creaNegozioEsercente(requestParameters: CreaNegozioEsercenteRequestParams, extraHttpRequestParams?: any): Observable<NegozioDTO>;

    /**
     * Elimina un proprio punto vendita.
     * Il cascade DB rimuove le assegnazioni cassiere (righe UserNegozio); gli account cassiere restano. 404 se di un\&#39;altra impresa.
     * @endpoint delete /api/v1/esercente/negozi/{id_negozio}
* @param requestParameters
     */
    deleteNegozioEsercente(requestParameters: DeleteNegozioEsercenteRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Dettaglio di un proprio punto vendita.
     * 404 privacy-preserving se il negozio è di un\&#39;altra impresa.
     * @endpoint get /api/v1/esercente/negozi/{id_negozio}
* @param requestParameters
     */
    getNegozioEsercente(requestParameters: GetNegozioEsercenteRequestParams, extraHttpRequestParams?: any): Observable<NegozioDTO>;

    /**
     * Elenca i propri punti vendita.
     * Ritorna una Page dei soli negozi del proprio ProfiloEsercente (Pageable standard).
     * @endpoint get /api/v1/esercente/negozi
* @param requestParameters
     */
    listNegoziEsercente(requestParameters: ListNegoziEsercenteRequestParams, extraHttpRequestParams?: any): Observable<PagedModelNegozioDTO>;

    /**
     * Modifica un proprio punto vendita.
     * PUT-replace di nome/indirizzo con optimistic lock (rispedire la version letta via GET; 409 su mismatch). 404 se di un\&#39;altra impresa.
     * @endpoint put /api/v1/esercente/negozi/{id_negozio}
* @param requestParameters
     */
    updateNegozioEsercente(requestParameters: UpdateNegozioEsercenteRequestParams, extraHttpRequestParams?: any): Observable<NegozioDTO>;

}
